import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container, Col, Row, Card, CardBody, CardText, CardHeader  } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { getData } from "./data"
import { Filters } from "./Filters"
import Table from "./Table"
import BarChart from "components/Common/BarChart"
import axios from "axios";
import {API_URL, sitename} from "../../../constants/constants";
import moment from "moment";
const MimoReport = props => {
  const [chartData, setChartData] = useState([])
  const [mimoData, setMimoData] = useState([])
  const [chartArray, setChartArray] = useState([])
  const [selectedMonth, setSelectedMonth] =useState(moment().format("YYYY-MM"))
  const [loadingMessage, setLoadingMessage] = useState("1")
  useEffect(() => {
    callChart()
    callReport()
  }, [])
  const callChart = () => {
    
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/mimo-chart`,
    })
        .then(function (response) {
          setChartData(response?.data?.data)
        })
        .catch(function (response) {
        })
  }

  const calculateTotals = () => {
    let totalUniqueDepositors = 0;
    let totalDeposits = 0;
    let totalUniqueWithdrawals = 0;
    let totalWithdrawn = 0;
  
    mimoData.forEach(data => {
      totalUniqueDepositors += data.unique_deposit;
      totalDeposits += data.deposit;
      totalUniqueWithdrawals += data.unique_withdraw;
      totalWithdrawn += data.withdraw;
    });
  
    return {
      totalUniqueDepositors,
      totalDeposits,
      totalUniqueWithdrawals,
      totalWithdrawn
    };
  };
  
  const totals = calculateTotals();

  const callReport = () => {
    setLoadingMessage("1")
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/mimo-report?month=${selectedMonth}`,
    })
        .then(function (response) {
          setMimoData(response?.data?.data)
          setLoadingMessage("0")
        })
        .catch(function (response) {
        })
  }
  useEffect(() => {
    callReport()
  },[selectedMonth])
  useEffect(() => {
    if(chartData){
      var withdrawArray=[]
      var depositArray=[]
      var dayArray=[]
      chartData.map(chart => {
      withdrawArray.push(chart.withdraw)
      depositArray.push(chart.deposite)
      dayArray.push(chart.day_name)
      });
      var mainArray=[];
      mainArray['withdraw']=withdrawArray;
      mainArray['deposit']=depositArray;
      mainArray['day']=dayArray;
      setChartArray(mainArray)

    }
  }, [chartData])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title="Admin"
            breadcrumbItem="MIMO REPORT"
          />
        </Container>
        <Row>
  <Col lg={3}>
    <Card>
      <CardHeader className="bg-transparent border-bottom text-uppercase">Unique Depositors</CardHeader>
      <CardBody>
        <blockquote className="card-blockquote mb-0">
          <CardText className="font-size-16">
            {totals.totalUniqueDepositors}
          </CardText>
        </blockquote>
      </CardBody>
    </Card>
  </Col>
  <Col lg={3}>
    <Card>
      <CardHeader className="bg-transparent border-bottom text-uppercase">Total Deposit</CardHeader>
      <CardBody>
        <blockquote className="card-blockquote mb-0">
          <CardText className="font-size-16">
            {totals.totalDeposits}
          </CardText>
        </blockquote>
      </CardBody>
    </Card>
  </Col>
  <Col lg={3}>
    <Card>
      <CardHeader className="bg-transparent border-bottom text-uppercase">Unique Withdrawals</CardHeader>
      <CardBody>
        <blockquote className="card-blockquote mb-0">
          <CardText className="font-size-16">
            {totals.totalUniqueWithdrawals}
          </CardText>
        </blockquote>
      </CardBody>
    </Card>
  </Col>
  <Col lg={3}>
    <Card>
      <CardHeader className="bg-transparent border-bottom text-uppercase">Total Withdrawn</CardHeader>
      <CardBody>
        <blockquote className="card-blockquote mb-0">
          <CardText className="font-size-16">
            {totals.totalWithdrawn}
          </CardText>
        </blockquote>
      </CardBody>
    </Card>
  </Col>
</Row>

        <Filters setSelectedMonth={setSelectedMonth}/>
        {
          chartArray?
              <BarChart data={chartArray}/> :''
        }
        {
          mimoData ?
              <Table data={mimoData} loadingMessage={loadingMessage}
            setLoadingMessage={setLoadingMessage} />
              : ''
        }

      </div>
    </React.Fragment>
  )
}

export default withRouter(MimoReport)
